// Pending sign-offs — real HumanApproval rows the current user can
// decide. Loaded on mount; refreshed after a decide call. M2 had this
// as a derived count from agent rows; M3 promotes it to first-class
// data backed by /api/v1/human_approvals.

import { createStore } from "./store"
import { api } from "../lib/api"

export const approvalsStore = createStore({
  byId: {},          // { [approvalId]: approvalPayload }
  byAgentId: {},     // { [agentId]: [approvalPayload, ...] }
  loaded: false,
  loadError: null,
  decidingId: null,  // id currently in flight; UI disables buttons
  decideError: null, // last decide error message
})

export async function loadApprovals(paths) {
  try {
    const { approvals } = await api.get(paths.human_approvals)
    const byId = {}
    const byAgentId = {}
    approvals.forEach((a) => {
      byId[a.id] = a
      ;(byAgentId[a.agent.id] ||= []).push(a)
    })
    approvalsStore.setState({ byId, byAgentId, loaded: true, loadError: null })
  } catch (e) {
    approvalsStore.setState({ loadError: e.message, loaded: true })
  }
}

export async function decideApproval(approval, decision, denyReason = null) {
  approvalsStore.setState({ decidingId: approval.id, decideError: null })
  try {
    const body = { decision }
    if (denyReason) body.deny_reason = denyReason
    const res = await api.post(`/api/v1/human_approvals/${approval.id}/decide`, body)
    // Decision succeeded — drop the approval from the local state.
    approvalsStore.setState((s) => {
      const { [approval.id]: _drop, ...byId } = s.byId
      const agentList = (s.byAgentId[approval.agent.id] || []).filter((a) => a.id !== approval.id)
      const byAgentId = { ...s.byAgentId }
      if (agentList.length) byAgentId[approval.agent.id] = agentList
      else delete byAgentId[approval.agent.id]
      return { ...s, byId, byAgentId, decidingId: null, decideError: null }
    })
    return res
  } catch (e) {
    approvalsStore.setState({ decidingId: null, decideError: e.message })
    throw e
  }
}

export function totalPending(state) {
  return Object.keys(state.byId).length
}

export function pendingForAgent(state, agentId) {
  return state.byAgentId[agentId] || []
}
